import { gql, useQuery } from '@apollo/client';
import { ReminderJourneys } from '../../../../generated/event.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const GET_REMINDER_JOURNEYS = gql`
  query getReminderJourneys {
    getReminderJourneys {
      _id
      name
      sfmcJourneyApiKey
      format
      timeInHour
      marketDefaults
      active
      channel
    }
  }
`;

type ResultType = {
  getReminderJourneys: ReminderJourneys[];
};

const useGetReminderJourneys = () => {
  const { data, loading, error, refetch } = useQuery<ResultType>(GET_REMINDER_JOURNEYS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
  });

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName: 'getReminderJourneys.ts - getReminderJourneys',
    });
  }

  return {
    data: data?.getReminderJourneys,
    loading,
    error,
    refetch,
  };
};

export default useGetReminderJourneys;
